
// @ts-nocheck


export const localeCodes =  [
  "de",
  "fr",
  "en"
]

export const localeLoaders = {
  de: [
    {
      key: "locale_de_46json_003ea729",
      load: () => import("#nuxt-i18n/003ea729" /* webpackChunkName: "locale_de_46json_003ea729" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_04510cf7",
      load: () => import("#nuxt-i18n/04510cf7" /* webpackChunkName: "locale_fr_46json_04510cf7" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_e2607e1d",
      load: () => import("#nuxt-i18n/e2607e1d" /* webpackChunkName: "locale_en_46json_e2607e1d" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/119d63e0" /* webpackChunkName: "config_i18n_46config_46js_119d63e0" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: false,
    dropMessageCompiler: true,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "de",
      files: [
        {
          path: "/usr/src/app/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      files: [
        {
          path: "/usr/src/app/i18n/locales/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      files: [
        {
          path: "/usr/src/app/i18n/locales/en.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: true,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "de",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "config",
  pages: {
    "search/Search": {
      de: "/suche/",
      fr: "/recherche/"
    },
    "account/Overview": {
      de: "/konto/",
      fr: "/compte/"
    },
    "account/address/Overview": {
      de: "/konto/adressen/",
      fr: "/compte/adresse/"
    },
    "account/address/Add": {
      de: "/konto/addressen/neu/",
      fr: "/compte/adresse/nouveau/"
    },
    "account/address/Edit": {
      de: "/konto/addressen/[id]/",
      fr: "/compte/adresse/editer/[id]/"
    },
    "checkout/Address": {
      de: "/checkout/gast/",
      fr: "/sortie-de-caisse/invite/"
    },
    "checkout/Shipping": {
      de: "/checkout/versand/",
      fr: "/sortie-de-caisse/expedition/"
    },
    "checkout/Summary": {
      de: "/checkout/ubersicht/",
      fr: "/sortie-de-caisse/resume/"
    },
    "checkout/Saferpay": {
      de: "/checkout/bezahlung/",
      fr: "/sortie-de-caisse/paiement/"
    },
    "checkout/PreLogin": {
      de: "/checkout/",
      fr: "/sortie-de-caisse/"
    },
    "checkout/ThankYou": {
      de: "/checkout/danke/",
      fr: "/sortie-de-caisse/merci/"
    },
    "account/OrderDetail": {
      de: "/konto/bestellung/[id]",
      fr: "/compte/commande/[id]"
    },
    "account/Member": {
      de: "/konto/mitglied/",
      fr: "/compte/profil"
    },
    "checkout/SaferpayCallback": {
      de: "/checkout/[kind]/[orderNumber]/[hash]",
      fr: "/checkout/[kind]/[orderNumber]/[hash]"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  dynamicRouteParams: false,
  redirectOn: "all",
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "de",
    files: [
      {
        path: "/usr/src/app/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    files: [
      {
        path: "/usr/src/app/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    files: [
      {
        path: "/usr/src/app/i18n/locales/en.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/